import API, { APIResponse } from '../index'

export const getUIBankAd = (type: string): Promise<APIResponse> =>
  API.request('GET', `/api/v1/ad/ui/${type}`, {}, true)
